var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts"
	],
	"./alianza/alianza.module": [
		"./src/app/alianza/alianza.module.ts",
		"alianza-alianza-module"
	],
	"./asistentes/asistentes.module": [
		"./src/app/asistentes/asistentes.module.ts"
	],
	"./associate/associate.module": [
		"./src/app/associate/associate.module.ts",
		"associate-associate-module"
	],
	"./comercial/comercial.module": [
		"./src/app/comercial/comercial.module.ts"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./medico/medico.module": [
		"./src/app/medico/medico.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;